(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-lumino-experience]').forEach(root => {
      if (root.experienceController) return;
      const controller = new AbortController();
      root.experienceController = controller;
      const { signal } = controller;
      const nav = root.querySelector('[data-lumino-product-nav]');
      const links = [...(nav?.querySelectorAll('[data-lumino-section-link]') || [])];
      const targets = links.map(link => document.getElementById(link.hash.slice(1)));
      let copy = {};
      try { copy = JSON.parse(root.querySelector('[data-lumino-review-translations]')?.textContent || '{}'); } catch {}
      if (copy.Verified) root.style.setProperty('--lumino-verified-text', JSON.stringify(copy.Verified));
      const translateText = text => {
        const value = text.trim();
        if (copy[value]) return text.replace(value, copy[value]);
        const count = value.match(/^(\d+) reviews?$/i);
        if (count) return copy.review_count?.replace('[count]', count[1]) || text;
        const based = value.match(/^Based on (\d+) reviews?$/i);
        if (based) return copy.review_based?.replace('[count]', based[1]) || text;
        const average = value.match(/^([\d.]+) out of 5$/i);
        if (average) return copy.review_average?.replace('[score]', average[1]) || text;
        return text;
      };
      const localizeReviews = () => {
        if (!Object.keys(copy).length) return;
        const selectors = '.jdgm-prev-badge__text,.jdgm-rev-widg__header,.jdgm-sort-dropdown-wrapper,.jdgm-form,.jdgm-rev__buyer-badge,.jdgm-rev__replier-wrapper';
        root.querySelectorAll(selectors).forEach(element => {
          const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
          while (walker.nextNode()) {
            const node = walker.currentNode;
            if (node.parentElement.closest('script,style,textarea,.jdgm-rev__body,.jdgm-rev__title,.jdgm-rev__author')) continue;
            const next = translateText(node.nodeValue);
            if (next !== node.nodeValue) node.nodeValue = next;
          }
        });
        root.querySelectorAll('.jdgm-widget input,.jdgm-widget textarea,.jdgm-widget [aria-label]').forEach(element => {
          for (const attribute of ['placeholder','aria-label']) {
            const before = element.getAttribute(attribute);
            if (before && copy[before]) element.setAttribute(attribute, copy[before]);
          }
          if (element.type === 'submit' && copy[element.value]) element.value = copy[element.value];
        });
        root.querySelectorAll('.jdgm-form p').forEach(paragraph => {
          if (!paragraph.textContent.trim().startsWith('How we use your data:')) return;
          [...paragraph.childNodes].forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
              if (node.nodeValue.includes('How we use your data:')) node.nodeValue = copy.privacy_prefix;
              else if (node.nodeValue.includes(' and ')) node.nodeValue = copy.privacy_and;
              else if (node.nodeValue.includes(' policies.')) node.nodeValue = copy.privacy_suffix;
            } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'A') {
              const label = { terms: copy.privacy_terms, privacy: copy.privacy_privacy, content: copy.privacy_content }[node.textContent.trim()];
              if (label) node.textContent = label;
            }
          });
        });
        root.querySelectorAll('.jdgm-link').forEach(link => {
          if (copy[link.textContent.trim()]) link.textContent = copy[link.textContent.trim()];
        });
      };
      let reviewFrame = 0;
      const reviewObserver = new MutationObserver(() => {
        if (!reviewFrame) reviewFrame = requestAnimationFrame(() => { reviewFrame = 0; localizeReviews(); });
      });
      if (Object.keys(copy).length) reviewObserver.observe(root, { childList: true, characterData: true, subtree: true });
      localizeReviews();
      root.querySelectorAll('[data-lumino-pickup-link]').forEach(link => {
        if (!document.getElementById(link.hash.slice(1))) {
          const delivery = root.querySelector('.lumino-delivery-target');
          if (delivery) link.href = `#${delivery.id}`;
        }
      });
      const setCurrent = link => {
        links.forEach(item => {
          if (item === link) item.setAttribute('aria-current', 'location');
          else item.removeAttribute('aria-current');
        });
      };
      root.addEventListener('click', event => {
        const link = event.target.closest('[data-lumino-section-link]');
        if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        const toggle = target.querySelector('[data-js-title][aria-expanded="false"]');
        toggle?.click();
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        setCurrent(link);
        requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          target.focus({ preventScroll: true });
        });
      }, { signal });
      let frame = 0;
      const updateCurrent = () => {
        frame = 0;
        const offset = nav?.getBoundingClientRect().bottom || 0;
        let current = links[0];
        targets.forEach((target, index) => {
          if (target && target.getBoundingClientRect().top <= offset + 80) current = links[index];
        });
        if (current) setCurrent(current);
      };
      window.addEventListener('scroll', () => {
        if (!frame) frame = requestAnimationFrame(updateCurrent);
      }, { signal, passive: true });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        controller.abort();
        reviewObserver.disconnect();
        if (reviewFrame) cancelAnimationFrame(reviewFrame);
        if (frame) cancelAnimationFrame(frame);
      }, { signal });
      updateCurrent();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
